import { useId } from "react";

import { FormType } from "@simplyk/common";

import { useFormV2Context } from "../../../contexts/FormV2Context";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormCheckbox } from "@/forms-design-system/FormCheckbox";

export const AuctionAnonymousBidCheckbox = () => {
  const { form } = useFormV2Context(FormType.Ticketing);
  const { t } = useTranslate();

  return (
    <FormCheckbox
      control={form.control}
      name="isAnonymous"
      id={useId()}
      label={t("ticketing", "auctionV2.isAnonymousBid")}
      defaultChecked={false}
    />
  );
};

export const useAuctionAnonymousBidCheckboxShouldRender = () => {
  const { isAuction } = useFormV2Context();
  return isAuction;
};
